import { BCEntityBase } from "../models/shared/BCEntityBase";
import config from "./config"

export const updateInvoices = async (): Promise<void> => {
    const endpoint = config.functions.updateInvoices;

    const response = await fetch(endpoint);
    if (!response.ok) {
        throw new Error(`Failed to call function: ${response.statusText}`);
    }
}

export const finalizeInvoice = async (token: string | undefined, invoiceId: string): Promise<void> => {
    const endpoint = config.functions.finalizeInvoice;
    const payload = { invoiceId };
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        const bodyText = await response.text();
        throw new Error(`Failed to call function: ${bodyText}`);
    }
}

export const handleAzureCode = async (code: string): Promise<void> => {
    const endpoint = config.functions.codeAzureAuth;
    const response = await fetch(`${endpoint}?code=${code}`);
    if (!response.ok) {
        throw new Error(`Failed to call function: ${response.statusText}`);
    }
}

export const azureGetCompanies = async (token: string | undefined): Promise<BCEntityBase[]> => {
    const endpoint = config.functions.azureGetCompanies;
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    });

    if (!response.ok) {
        const bodyText = await response.text();
        throw new Error(`Failed to call function: ${bodyText}`);
    }
    const data = await response.json();
    console.log('Azure companies data:', data);
    return data.results || [];
}

export const azureGetCustomers = async (token: string | undefined, companyId: string): Promise<BCEntityBase[]> => {
    const endpoint = config.functions.azureGetCustomers;
    const response = await fetch(`${endpoint}?companyId=${companyId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    });

    if (!response.ok) {
        const bodyText = await response.text();
        throw new Error(`Failed to call function: ${bodyText}`);
    }
    const data = await response.json();
    console.log('Azure customers data:', data);
    return data.results || [];
}

export const azureGetItems = async (token: string | undefined, companyId: string): Promise<BCEntityBase[]> => {
    const endpoint = config.functions.azureGetItems;
    const response = await fetch(`${endpoint}?companyId=${companyId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    });

    if (!response.ok) {
        const bodyText = await response.text();
        throw new Error(`Failed to call function: ${bodyText}`);
    }
    const data = await response.json();
    console.log('Azure items data:', data);
    return data.results || [];
}
